import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

function FAQAccordion({ items = [], defaultOpenIndex = 0 }) {
  const [activeIndex, setActiveIndex] = useState(defaultOpenIndex);

  return (
    <div className="space-y-3">
      {items.map((item, index) => {
        const isActive = activeIndex === index;

        return (
          <article
            key={item.question}
            className={`overflow-hidden rounded-2xl border bg-white shadow-card transition-all duration-300 ${
              isActive
                ? "border-brand-gold/30 shadow-elevated"
                : "border-brand-line/40 hover:border-brand-line/70"
            }`}
          >
            <button
              type="button"
              className="flex w-full items-start justify-between gap-4 px-5 py-4 text-left"
              aria-expanded={isActive}
              aria-controls={`faq-content-${index}`}
              onClick={() => setActiveIndex((prev) => (prev === index ? -1 : index))}
            >
              <span className="text-sm font-bold leading-relaxed text-brand-navy sm:text-base">
                {item.question}
              </span>
              <span
                className={`mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                  isActive
                    ? "bg-brand-gold/15 text-brand-gold-strong rotate-180"
                    : "bg-brand-sky/50 text-brand-charcoal/60"
                }`}
              >
                <ChevronDown className="h-4 w-4" />
              </span>
            </button>

            <AnimatePresence initial={false}>
              {isActive ? (
                <motion.div
                  key="faq-content"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
                  id={`faq-content-${index}`}
                  className="overflow-hidden"
                >
                  <div className="border-t border-brand-line/30 px-5 py-4">
                    <p className="text-sm leading-[1.8] text-brand-charcoal/75">{item.answer}</p>
                  </div>
                </motion.div>
              ) : null}
            </AnimatePresence>
          </article>
        );
      })}
    </div>
  );
}

export default FAQAccordion;
